import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  .CommunityFeatures {
    max-width: 960px;
  }
  .CommunityFeatures_group {
    border-bottom: 1px solid #DBDADA;
    display: flex;
    flex-direction: column;
    padding: 50px 0;
    @media (min-width: 992px) {
      flex-direction: row;
      &:nth-child(2n) {
        flex-direction: row-reverse;
        .CommunityFeatures_listWrapper {
          margin-left: 90px;
        }
      }
      &:nth-child(2n + 1) {
        .CommunityFeatures_image {
          margin-left: 45px;
        }
      }
    }
  }
  .CommunityFeatures_title {
    text-transform: uppercase;
    font-family: ${typography.Serif};
    font-size: 1.5rem;
    color: ${colors.color5Light};
    letter-spacing: 4px;
    position: relative;
    margin-bottom: 30px;

    &:after {
      width: 75px;
      height: 3px;
      position: absolute;
      display: block;
      content: '';
      bottom: -20px;
      background-color: ${colors.color2};
    }
  }
  .CommunityFeatures_listWrapper {
    flex-grow: 1;
  }
  .CommunityFeatures_list {
    padding-left: 25px;

    li {
      padding: 10px;
      font-size: 18px;
      list-style: none;
      position: relative;

      &:after {
        content: '';
        height: 10px;
        width: 10px;
        background: #DBDADA;
        display: block;
        position: absolute;
        top: 18px;
        left: -25px;
      }
    }
  }
  .CommunityFeatures_image {
    flex-grow: 1;
    width: 100%;
    img {
      width: 100%;
    }
    @media (min-width: 992px) {
      max-width: 400px;
    }
  }
`;

function CommunityFeatures({ community }) {
  return (
    <div className={styles}>
      <div className="CommunityFeatures container">
        {
          get(community, 'features', []).map(featureGroup => {
            return (
              <div className="CommunityFeatures_group" key={featureGroup.title}>
                <div className="CommunityFeatures_listWrapper">
                  <h3 className="CommunityFeatures_title">{featureGroup.title}</h3>
                  <ul className="CommunityFeatures_list">
                    {
                      featureGroup.features_list.map(feature => {
                        return (
                          <li key={feature}>{feature}</li>
                        );
                      })
                    }
                  </ul>
                </div>
                <div className="CommunityFeatures_image">
                  { featureGroup.image &&
                    <img src={featureGroup.image.contentUrl} alt={featureGroup.title} />
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

CommunityFeatures.propTypes = {
  community: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(CommunityFeatures);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityFeatures.js